module.exports = __webpack_public_path__ + "images/noon-logo-pms2336c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/noon-logo-pms2336c.png
// module id = 268
// module chunks = 0